module.exports = __webpack_public_path__ + "static/img/mood10.0bad2f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood10.png
// module id = yFHk
// module chunks = 1